import React, { useState } from 'react';
import styled from 'styled-components';
import { TextField } from 'ceci-ui';
import SearchIcon from '@material-ui/icons/Search';

const Wrapper = styled.form`
  margin: 0 60px;
  min-width: 230px;
`;

function HeaderSearchBox() {
  const [term, setTerm] = useState<string>('');

  function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    console.log('submit search form', term);
  };

  return (
    <Wrapper onSubmit={handleSubmit}>
      <TextField
        InputProps={{ disableUnderline: true }}
        value={term}
        onChange={setTerm}
        placeholder="Procurar"
        leftIcon={<SearchIcon />}
        variant="standard" />
    </Wrapper>
  )
};

export default HeaderSearchBox;

